import {
	Toaster as ChakraToaster,
	Portal,
	Spinner,
	Stack,
	Toast,
	createToaster,
} from '@chakra-ui/react';

import React from 'react';

const toaster = createToaster({
	placement: 'top',
	pauseOnPageIdle: true,
	duration: 5000
});


export const Manager = () => {
	return (
		<Portal>
			<ChakraToaster toaster={toaster} insetInline={{ mdDown: '4' }}>
				{(toast) => (
					<Toast.Root width={{ md: 'sm' }}>
						{toast.type === 'loading' ? (
							<Spinner size="sm" color="blue.solid" />
						) : (
							<Toast.Indicator />
						)}
						<Stack gap="1" flex='1' maxWidth="100%">
							{toast.title && <Toast.Title>{toast.title}</Toast.Title>}
							{toast.description && (
								<Toast.Description>{toast.description}</Toast.Description>
							)}
						</Stack>
						{toast.action && (
							<Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>
						)}
						{toast.meta?.closable && <Toast.CloseTrigger />}
					</Toast.Root>
				)}
			</ChakraToaster>
		</Portal>
	);
};

export function error(message: string) {
	toaster.create({ title: message, type: 'error' });
}

export function warn(message: string) {
	toaster.create({ title: message, type: 'warning' });
}

export function info(message: string) {
	toaster.create({ title: message, type: 'info' });
}

export function success(message: string) {
	toaster.create({ title: message, type: 'success' });
}
